function randomElementId(prefix: string): () => string {
  return () => {
    let id = prefix || 'element';
    id += (Math.random()).toFixed(10).substring(2);
    return id;
  };
}

export { randomElementId };
